import type { Colors, DefaultTheme } from 'styled-components';
import { Direction } from '../../types/Direction';
import { darkColors, mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  primary: {
    lighten: '#6ec8fe',
    default: '#3cb5fd',
    dim: 'rgba(60,181,253,0.4)',
    mute: 'rgba(60,181,253,0.1)',
  },
  gray: {
    main: '#010101',

    '000': '#000000',
    '010': '#121212',
    '020': '#232323',
    '030': '#343434',
    '040': '#454545',
    '050': '#565656',
    '060': '#676767',
    '070': '#787878',
    '080': '#898989',
    '090': '#9a9a9a',
    '100': '#ababab',
  },
  green: {
    lighten: '#3ca371',
    default: '#2E7E57',
    dim: 'rgba(46,126,87,0.4)',
    mute: 'rgba(46,126,87,0.1)',
  },
  red: {
    lighten: '#c74454',
    default: '#A63240',
    dim: 'rgba(166,50,64,0.4)',
    mute: 'rgba(166,50,64,0.1)',
  },
  yellow: {
    lighten: '#d7bd66',
    default: '#CCAC3E',
    dim: 'rgba(204,172,62,0.4)',
    mute: 'rgba(204,172,62,0.1)',
  },
  orange: {
    lighten: '#ff6c1a',
    default: '#E65200',
    dim: 'rgba(230,82,0,0.4)',
    mute: 'rgba(230,82,0,0.1)',
  },

  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
  purple: darkColors.purple,
  blue: darkColors.blue,
};

export const DarkTDATheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkTDA',

  fontFamily: "'Geist', sans-serif;",
  fontUrl: 'https://fonts.googleapis.com/css2?family=Geist:wght@@300;400;500;600;700&display=swap',
  colorTextAttention: colors.white.default,
  colorTextImportant: colors.white.default,
  colorTextMuted: colors.white.dim,

  backgroundBody: colors.gray['010'],
  backgroundHeader: colors.gray.main,
  borderColorHeader: colors.gray.main,
  backgroundSidebar: colors.gray.main,

  backgroundDropdown: colors.gray['010'],
  backgroundDropdownInput: colors.gray['010'],
  backgroundDropdownGroupHeader: colors.gray['010'],
  backgroundDropdownSelected: colors.gray['030'],
  backgroundDropdownHovered: colors.gray['020'],

  borderColorDivider: colors.gray['020'],
  borderRadiusContent: 3,
  spacingLayout: 8,

  borderColorChartGridLine: colors.gray['020'],
  borderColorChartAxis: colors.gray['020'],

  backgroundVolumeLadderBidSpread: colors.gray['060'],
  backgroundVolumeLadderOfferSpread: colors.gray['060'],
  backgroundVolumeLadderTransparencyDirection: Direction.Desc,

  borderColorInput: colors.gray['040'],
  borderColorInputHover: colors.gray['060'],
  borderColorInputFocus: colors.gray['040'],

  colorTabHover: colors.gray['070'],

  boxShadowContent: '0 2px 16px rgba(0, 0, 0, 0.75)',
  boxShadowHeader: '0 2px 16px rgba(0, 0, 0, 0.75)',
  backgroundToggle: colors.gray['010'],
  backgroundPopover: colors.gray.main,
  backgroundPopoverHighlight: colors.gray['010'],
  backgroundSidebarItemActive: colors.gray['020'],
  backgroundSidebarItemHover: colors.gray['030'],
});
